module.exports = __webpack_public_path__ + "static/media/protech.dd959854.jpg";